import React, { useContext, useState, useRef, useEffect } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from './ui/Avatar';
import { SessionContext } from '../contexts/SessionContext';
import { generateColor, getlogoutFlag } from '../utils';
// import { msalApp } from '../authConfig';
import { useMsal } from '@azure/msal-react';
import { TooltipTrigger } from '@radix-ui/react-tooltip';
import { Tooltip, TooltipProvider } from './ui/Tooltip';
import { TooltipContent } from '@radix-ui/react-tooltip';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { trackUserClicks } from '../utils';
import { APIContext } from '../contexts/APIContext';
import useOutsideClickHandler from '../hooks/useOutsideClickHandler';
import { getInitialsFromUName, getValidToken } from '../utils';
import { msalInstance } from '..';

export const Header = () => {
  const {
    websocketConnectionRef: { current: websocket },
    userDetails,
    chatSessionId,
    WBUId,
    AppName,
    accounts,
    stopSignalRConnection,
  } = useContext(APIContext);
  const { accountDetails } = useContext(SessionContext);
  const {
    userDetails: { User_ProfileImage: profileImg },
  } = useContext(APIContext);
  const initialsof = getInitialsFromUName(accounts[0].name ?? '');
  const avatar = !accountDetails.initials ? (
    <Avatar>
      <AvatarFallback>{initialsof}</AvatarFallback>
    </Avatar>
  ) : (
    <Avatar>
      <AvatarImage src={`data:image/jpeg;base64,${profileImg?.result}`} className="AvatarImage"></AvatarImage>
      <AvatarFallback>{accountDetails.initials}</AvatarFallback>
    </Avatar>
  );
  // const { accounts } = useMsal();
  const [openLogout, setOpenLogout] = useState(false);
  const logoutRef = useRef(null);

  const handleOpenLogout = () => {
    setOpenLogout(!openLogout);
  };

  const handleOustsideClickLogout = () => {
    setOpenLogout(false);
  };

  useOutsideClickHandler('logout_dropdown', handleOustsideClickLogout);

  const handleLogout = async () => {
    const token = await getValidToken();
    trackUserClicks(websocket, 'GMA Logout', userDetails, chatSessionId, WBUId, AppName, accounts, token);
    getlogoutFlag(websocket, accounts, token);
    await stopSignalRConnection();
    msalInstance.logoutRedirect();
  };

  return (
    <>
      <div className="bg-[#EEE] h-[54px] flex flex-row justify-between px-4 border-b-[2px] border-b-[#961FFC] fixed w-full top-0 left-0 z-[51]">
        <div className="flex flex-row items-center">
          <div className="">
            <img src="/icons/brand.svg" alt="Accenture" className="w-12 h-12 tablet:w-[43] tablet:h-[26]" />
          </div>
          <div>
            <p className="color-[#000] font-graphik font-medium text-xs ml-1 tablet:text-[14px] text-left tablet:ml-2">
              {' '}
              Corporate Strategy & Growth | Growth.AI{' '}
            </p>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center">
          <div className="flex flex-row cursor-pointer" id="logout_dropdown">
            <div
              className={`flex flex-col justify-center items-center rounded-full text-white cursor-pointer`}
              style={{ backgroundColor: generateColor(accountDetails.initials ?? '..') }}
              onClick={handleOpenLogout}
            >
              {avatar}
            </div>
            <img src="/icons/notification.svg" alt="avatar" className="absolute ml-[24px] tablet:ml-[28px]" />
          </div>
        </div>
      </div>
      {openLogout && (
        <div
          ref={logoutRef}
          className="fixed top-[3.2rem] right-[2.5rem] w-[190px] tablet:w-[264px] h-[303px] bg-[#FFFFFF] shadow-md  z-[55]"
        >
          <div className="header_logout">
            <div className="flex flex-col w-full justify-center text-start mb-2 px-4 py-6">
              <div className="flex flex-row gap-2 items-center">
                <div
                  className="flex justify-center h-[32px] w-[32px] items-center rounded-full text-white"
                  style={{ backgroundColor: generateColor(accountDetails.initials ?? '..') }}
                >
                  {avatar}
                </div>
                <div>
                  <p className="font-bold text-sm">{accounts[0].name}</p>
                  {/* <p className="text-xs font-normal">designation</p> */}
                </div>
              </div>
            </div>
            <hr></hr>
            <div className="flex flex-col text-start text-sm font-normal gap-4 text-[#CCCCCC] px-5 py-5">
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger>
                    <div className="language-icon flex items-center gap-2 hover:text-[#A100FF] cursor-pointer">
                      <img src="/icons/earthIcon.svg" alt="language" className="w-4 h-4 cursor-pointer" />
                      <p>English</p>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent
                    side="bottom"
                    className="bg-white border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 mr-32"
                    sideOffset={2}
                  >
                    <p className="tooltip-content text-black bg-white text-xs not-italic">Coming soon</p>
                    <TooltipPrimitive.Arrow style={{ fill: '#FFFFFF' }} />
                  </TooltipContent>
                </Tooltip>

                <Tooltip>
                  <TooltipTrigger>
                    <div className="help-icon flex items-center gap-2 hover:text-[#A100FF] cursor-pointer">
                      <img src="/icons/helpIcon.svg" alt="help" className="w-4 h-4" />
                      <p>Help</p>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent
                    side="bottom"
                    className="bg-white border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 mr-32"
                    sideOffset={2}
                  >
                    <p className="tooltip-content text-black bg-white text-xs not-italic">Coming soon</p>
                    <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#FFFFFF' }} />
                  </TooltipContent>
                </Tooltip>

                <Tooltip>
                  <TooltipTrigger>
                    <div className="workspaces-icon flex items-center gap-2 hover:text-[#A100FF] cursor-pointer">
                      <img src="/icons/workspaceIcon.svg" alt="workspaces" className="w-4 h-4" />
                      <p>myWorkspaces</p>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent
                    side="bottom"
                    className="bg-white border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 mr-32"
                    sideOffset={2}
                  >
                    <p className="tooltip-content text-black bg-white text-xs not-italic">Coming soon</p>
                    <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#FFFFFF' }} />
                  </TooltipContent>
                </Tooltip>

                <Tooltip>
                  <TooltipTrigger>
                    <div className="settings-icon flex items-center gap-2 hover:text-[#A100FF] cursor-pointer">
                      <img src="/icons/settingsIcon.svg" alt="settings" className="w-4 h-4" />
                      <p>Settings</p>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent
                    side="bottom"
                    className="bg-white border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 mr-32"
                    sideOffset={2}
                  >
                    <p className="tooltip-content text-black bg-white text-xs not-italic">Coming soon</p>
                    <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#FFFFFF' }} />
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
            <hr></hr>
            <div className="text-start text-[#A100FF] font-normal mt-2 px-5 cursor-pointer" onClick={handleLogout}>
              Logout
            </div>
          </div>
        </div>
      )}
    </>
  );
};
